
export function setRpaUrl(url) {
    return (dispatch, getState, { rcsdk, rcAlgolia, rcRPA }) => {
        rcRPA.setUrl(url)
    }
};